/**
 * Constants for form fields group identification
 */
export const FORM_FIELDS_GROUP = '_form_fields_group';
export const FORM_FIELDS_ID = '_form_fields';
export const TEXT_FORM = '_text_form';
export const CHECKBOX = '_checkbox';
export const DROPDOWN = '_dropdown';
/**
 * FormFieldsGroup module
 * @private
 */
export class FormFieldsGroup {
    /**
     * Constructor for FormFieldsGroup class
     * @param {DocumentEditorContainer} container - DocumentEditorContainer instance
     */
    constructor(container) {
        this.container = container;
        this.ribbonId = this.container.element.id + '_ribbon';
    }
    /**
     * Get the DocumentEditor instance
     * @returns {DocumentEditor} The DocumentEditor instance
     */
    get documentEditor() {
        return this.container.documentEditor;
    }
    /**
     * Get the FormFields group model
     * @returns {RibbonGroupModel} The FormFields group model
     */
    getGroupModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId + FORM_FIELDS_GROUP;
        return {
            id: id,
            header: locale.getConstant('Form Fields'),
            orientation: 'Row',
            cssClass: 'e-formfields-group',
            enableGroupOverflow: true,
            overflowHeader: locale.getConstant('Form Fields'),
            collections: [
                {
                    items: [
                        this.getFormFieldsDropDownModel()
                    ]
                }
            ]
        };
    }
    /**
     * Get the FormFields dropdown model
     * @returns {RibbonItemModel} The FormFields dropdown model
     */
    getFormFieldsDropDownModel() {
        const locale = this.container.localObj;
        const id = this.ribbonId;
        return {
            type: 'DropDown',
            id: id + FORM_FIELDS_ID,
            dropDownSettings: {
                iconCss: 'e-icons e-de-formfield',
                content: locale.getConstant('Form Fields'),
                items: [
                    {
                        text: locale.getConstant('Text Form'),
                        iconCss: 'e-icons e-de-textform',
                        id: id + TEXT_FORM
                    },
                    {
                        text: locale.getConstant('Check Box'),
                        iconCss: 'e-icons e-de-checkbox-form',
                        id: id + CHECKBOX
                    },
                    {
                        text: locale.getConstant('DropDown'),
                        iconCss: 'e-icons e-de-dropdownform',
                        id: id + DROPDOWN
                    }
                ],
                select: this.onFormFieldsDropDownSelect.bind(this)
            },
            ribbonTooltipSettings: {
                content: locale.getConstant('Insert form fields')
            }
        };
    }
    /**
     * Handle form fields dropdown selection
     * @param {MenuEventArgs} args - Menu event arguments
     * @returns {void}
     */
    onFormFieldsDropDownSelect(args) {
        const id = this.ribbonId;
        if (args.item.id === id + TEXT_FORM) {
            this.documentEditor.editorModule.insertFormField('Text');
        }
        else if (args.item.id === id + CHECKBOX) {
            this.documentEditor.editorModule.insertFormField('CheckBox');
        }
        else if (args.item.id === id + DROPDOWN) {
            this.documentEditor.editorModule.insertFormField('DropDown');
        }
        setTimeout(() => {
            this.documentEditor.focusIn();
        }, 30);
    }
    /**
     * Update UI based on current selection
     * @returns {void}
     */
    updateSelection() {
        const isHeaderFooter = this.documentEditor.selection.contextType.indexOf('Header') >= 0 ||
            this.documentEditor.selection.contextType.indexOf('Footer') >= 0;
        const ribbon = this.container.ribbon.ribbon;
        if (ribbon) {
            if (isHeaderFooter) {
                ribbon.disableItem(this.ribbonId + FORM_FIELDS_ID);
            }
            else {
                ribbon.enableItem(this.ribbonId + FORM_FIELDS_ID);
            }
        }
    }
    /**
     * Destroy the FormFieldsGroup instance
     * @returns {void}
     */
    destroy() {
        // Destroy UI components
        if (this.formFieldDropDown) {
            this.formFieldDropDown.destroy();
            this.formFieldDropDown = undefined;
        }
        // Clear all references
        this.container = undefined;
        this.ribbonId = undefined;
    }
}
